<template>
  <b-card>
    <b-form @reset="resetFilter" v-on:submit.prevent>
      <fieldset :disabled="loading">
        <b-form-group id="category-group" :label="$t('category')" label-for="category">
          <b-form-select size="sm" id="category" v-model="filter.category" :options="categories" @change="updateEvents">
            <template slot="first">
              <option :value="null">{{ $t('all')}}</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="application-group" :label="$t('application')" label-for="application">
          <b-form-select size="sm" id="application" v-model="filter.application" :options="applications" @change="updateEvents">
            <template slot="first">
              <option :value="null">{{ $t('all')}}</option>
            </template>
          </b-form-select>
        </b-form-group>


        <b-form-group id="message-group" :label="$t('message')" label-for="message">
          <b-form-input size="sm" id="message" type="text" v-model="filter.message" v-on:keyup="onKeyup"/>
        </b-form-group>

        <label for="from">{{ $t('from') }}</label>
        <b-form-datepicker size="sm" id="fromDate" class="mb-2" reset-button locale="langCode" :label-reset-button="$t('reset')" reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.lastSeenFrom"/>

        <label for="to">{{ $t('to') }}</label>
        <b-form-datepicker size="sm" id="to" class="mb-4" reset-button locale="langCode" :label-reset-button="$t('reset')" reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.lastSeenTo"/>
        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" type="reset" class="float-right">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>
      </fieldset>
    </b-form>
  </b-card>

</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters  } from 'vuex'

  export default {
    name: 'EventFilter',
    extends: BaseComponent,

    computed: {
      ...mapGetters('events', ['filter', 'paging', 'applications', 'categories', 'loading']),
    },
    methods: {
      resetFilter () {
        this.$store.dispatch('events/resetFilter')
        this.updateEvents()
      },

      onKeyup (event) {
        if (event.which === 13) {
          this.updateEvents()
        }
      },

      updateEvents () {
        this.$store.dispatch('events/getEvents')
      }
    },

    watch: {
      "paging.perPage": function() {
        this.updateEvents()
      },
      "paging.currentPage": function() {
        this.updateEvents()
      },
      "filter.lastSeenFrom": function () {
        this.updateEvents()
      },
      "filter.lastSeenTo": function () {
        this.updateEvents()
      }
    },
    mounted() {
      this.$store.dispatch('events/getApplications')
      this.$store.dispatch('events/getCategories')
    }
  }
</script>
